import React, {FC} from "react";

export type FormattedDaysAgoProps = {
    date: Date;
    className?: string;
}

export const FormattedDaysAgo: FC<FormattedDaysAgoProps> = React.memo(({date, className}) => {
        const now = new Date();

        const diffInMs = now.getTime() - date.getTime();
        const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

        let text: string;

        if (diffInDays === 0) {
            text = "Today";
        } else if (diffInDays === 1) {
            text = "Yesterday";
        } else {
            text = `${diffInDays} days ago`;
        }

        return <span className={className}>{text}</span>;
    })
;
